<template>
  <v-container class="fill-height" fluid>
    <v-row justify="center" v-if="data.plan">
      <v-col cols="12" sm="10" md="6" xl="4">
        <div class="plan primary white--text">
          <h2>{{ data.plan.name }}</h2>
          <p>{{ data.plan.details }}</p>
          <p class="cost">{{ data.plan.cost }}</p>
        </div>
        <v-card class="pa-5" v-if="data.plan">
          <v-card-text>
            <h1 v-if="data.plan.type === 'recurring'">Subscription Summary</h1>
            <h1 v-else-if="data.plan.type === 'onetime'">Order Summary</h1>
            <h1 v-else>Summary</h1>

            <v-divider class="my-4"></v-divider>

            <div class="mb-6">
              <h3 class="subtitle-1 font-weight-bold mb-2">Included in this plan:</h3>
              <ul class="features-list-summary">
                <li v-for="(value, key) in data.plan.limits" :key="key" class="mb-1 d-flex align-center">
                  <v-icon small color="primary" class="mr-2">mdi-check-circle</v-icon>
                  <span class="feature-text">
                    <strong>{{ value }}</strong> {{ key.replace(/_/g, " ") }}
                  </span>
                </li>
              </ul>
            </div>

            <v-simple-table class="mt-5">
              <thead class="grey lighten-5">
                <tr>
                  <th class="text-left">Item</th>
                  <th class="text-right">{{ data.plan.type === "recurring" ? "Subscription" : "Price" }}</th>
                  <th class="text-right">Total with Tax</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <b>{{ data.plan.name }}</b>
                  </td>
                  <td class="text-right">{{ data.plan.cost }}</td>
                  <td class="text-right">{{ (data.plan.amount * (1 + data.plan.taxPerc * 0.01)).toFixed(2) }} {{ defaultCurrency }}</td>
                </tr>
              </tbody>
              <tfoot class="grey lighten-5">
                <tr>
                  <td></td>
                  <td class="text-right">Subtotal</td>
                  <td class="text-right">{{ (data.plan.amount * 1).toFixed(2) }} {{ defaultCurrency }}</td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-right">Taxes</td>
                  <td class="text-right">{{ (data.plan.amount * (data.plan.taxPerc * 0.01)).toFixed(2) }} {{ defaultCurrency }}</td>
                </tr>
                <tr class="font-weight-bold">
                  <td></td>
                  <td class="text-right ">{{ data.plan.type === "recurring" ? "Monthly Total" : "Total" }}</td>
                  <td class="text-right ">{{ (data.plan.amount * (1 + data.plan.taxPerc * 0.01)).toFixed(2) }} {{ defaultCurrency }}</td>
                </tr>
              </tfoot>
            </v-simple-table>
            <v-divider></v-divider>

            <div class="text-right">
              <form ref="checkoutForm" @submit.prevent="submitForm" class="my-5" aria-autocomplete="off" autocomplete="off" method="post" :action="checkoutSessionUrl">
                <input type="hidden" name="email" :value="user.email" />
                <input type="hidden" name="lookup_key" :value="data.plan.pg_plan_lookup" required />
                <input name="amount" :value="data.amount" type="hidden" required />
                <v-btn color="primary" type="submit" id="checkout-and-portal-button">Checkout</v-btn>
              </form>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn text type="button" @click="gotoPlans">Change Plan</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {loadStripe} from "@stripe/stripe-js"
import plansData from "@/assets/plans/plans.json"

import axios from "axios"
import Vue from "vue"
import Component from "vue-class-component"
import {config} from "@/libs/utils"
import {cacheSrv} from "../../libs/cache/cache"

@Component
export default class Payment extends Vue {
  defaultCurrency = config.VUE_APP_CURRENCY_DEFAULT

  paymentUrl = config.VUE_APP_SERVER_PAYMENT_API
  publicToken = config.VUE_APP_PAYMENT_PUBLIC_TOKEN
  checkoutSessionUrl = config.VUE_APP_SERVER_PAYMENT_API + "/v1/secure/user/payment/create-checkout-session"

  plans = plansData.plans
  data = {
    plan: null,
    amount: 0,
  }
  user = this.$store.getters.profile
  token

  async loadPlans() {
    console.log("Mounted Payment Page")
    try {
      const response = await fetch(`${process.env.BASE_URL}plans/plans.json`)
      if (response.ok) {
        const data = await response.json()
        if (data && data.plans) {
          this.plans = data.plans
        }
      }
    } catch (error) {
      // Optionally handle error
      // console.error('Failed to fetch plans:', error)
    }
  }

  created() {
    this.loadAndSetupPlans()
  }

  async loadAndSetupPlans() {
    await this.loadPlans()
    console.log("Created Payment Page")
    const planId = this.$route.params.planId
    console.log("Plan ID", planId)

    this.$nextTick(() => {
      let plan = this.plans.find((plan) => plan.id == planId)
      if (!plan) {
        console.log("Plan not found")
        this.$router.push({name: "mapview"})
        return
      }
      Vue.set(this.data, "plan", plan)
      Vue.set(this.data, "amount", plan.amount)
    })
  }

  getToken() {
    const CACHE_KEY_SERVER = "mainmap"
    if (!this.token) {
      this.token = cacheSrv.cached(CACHE_KEY_SERVER + "_tok")
    }
    if (!this.token) {
      return null
    }
    return this.token
  }

  submitForm() {
    console.log("Submitting form")
    const form = this.$el.querySelector("form")
    if (form) {
      this.getToken()
      //append token to the form param
      const tokenInput = document.createElement("input")
      tokenInput.type = "hidden"
      tokenInput.name = "token"
      tokenInput.value = this.token
      form.appendChild(tokenInput)

      form.submit()
    }
  }

  async submitPayment() {
    console.log("Submitting payment")
    try {
      // Step 1: Get the client secret from the backend
      const response = await axios.post(paymentUrl + "/v1/secure/user/payment/create-payment-intent", {
        amount: this.amount,
      })

      const clientSecret = response.data.clientSecret

      // Step 2: Load Stripe.js
      const stripe = await loadStripe(publicToken)

      // Step 3: Confirm the payment
      const {error} = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
        },
      })

      if (error) {
        console.error(error)
        alert("Payment failed")
      } else {
        alert("Payment successful!")
      }
    } catch (error) {
      console.error(error)
      alert("An error occurred")
    }
  }

  gotoPlans() {
    this.$router.push({name: "plans"})
  }
}
</script>

<style>
.plan {
  border: 1px solid #ccc;
  padding: 20px;
}

.cost {
  font-weight: bold;
  margin: 10px 0;
}
.large-field {
  font-size: 20px;
  font-weight: bold;
}
.large-field.amount {
  width: 200px;
}
.features-list-summary {
  list-style: none;
  padding: 0;
}
.feature-text {
  font-size: 0.95rem;
  color: #444;
  text-transform: capitalize;
}
</style>
